export enum NotificationType {
  NOTIFICATION = 'notification',
  CONFIRMATION = 'confirmation',
  ALERT = 'alert',
  CLEAR = 'clear',
}
